/**
 * Converts an hex color string to rgb object
 * @param  {string} hex The hex color
 * @return {Object}     The rgb color
 */
export const hexToRgb = hex => {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
  hex = hex.replace(shorthandRegex, (m, r, g, b) => {
    return r + r + g + g + b + b
  })

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : null
}

/**
 * Converts an hex color string to rgba string
 * @param  {string} hex     The hex color
 * @param  {string} alpha   The desired alpha
 * @return {string}         The rgba string
 */
export const hexToRgba = (hex, alpha) => {
  const rgbObj = hexToRgb(hex)
  return `rgba(${rgbObj.r}, ${rgbObj.g}, ${rgbObj.b}, ${alpha})`
}



// WEBPACK FOOTER //
// ./styles/tools/colorMapper.js